import React from 'react';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import { NavLink } from 'react-router-dom';

const Tabs = props => {
    const { links, classes, ...rest } = props;
    const allTabs = links.map(link => (
        <NavLink
            key={link.to}
            to={link.to}
            exact
            activeClassName={classes.selected}
        >
            {link.name}
        </NavLink>
    ));
    return (
        <nav className={classes.nav} {...rest}>
            {allTabs}
        </nav>
    );
};

Tabs.propTypes = {
    links: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.node.isRequired,
            to: PropTypes.string.isRequired,
        }).isRequired,
    ).isRequired,
};

const style = ({ palette, spacing, tab }) => ({
    nav: {
        display: 'flex',
        alignItems: 'center',
        '& a': {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            textTransform: 'uppercase',
            padding: spacing.unit,
            textDecoration: 'none',
            whiteSpace: 'nowrap',
            minWidth: tab.itemWidth,
            fontWeight: '600',
        },
        '& a:not($selected)': {
            color: palette.text.primary,
            borderBottom: '2px solid transparent',
        },
    },
    selected: {
        borderBottom: {
            color: palette.primary.main,
            width: 2,
            style: 'solid',
        },
        color: palette.primary.main,
    },
});

export default injectSheet(style)(Tabs);



// WEBPACK FOOTER //
// ./src/components/Tabs.js